<template>
    <div class="main">
        <c-panel>
            <tabulacao-list tipo="BASE"></tabulacao-list>
        </c-panel>
    </div>
</template>

<script>
import TabulacaoList from '@/components/tabulacao/shared/tabulacao-list.vue'

export default {
    components: { TabulacaoList }
}
</script>
